import React from 'react';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';
import store from '../Redux/store';
import { logout } from '../Redux/user/slice';
import { ToastProperties } from './constants/toastProperties';

/**
 * Wrapper for fetch that handles 401 responses (expired tokens)
 * Automatically logs out user and shows login modal
 */
export const authFetch = async (url, options = {}) => {
  try {
    const response = await fetch(url, options);
    
    // Check for 401 Unauthorized (expired token)
    if (response.status === 401) {
      console.warn('Token expired - logging out user');
      
      // Show toast notification with translated message
      toast.error(<FormattedMessage id="toast.sessionexpired" />, ToastProperties);
      
      // Only clear auth-related keys, not all localStorage
      // (localStorage.clear() would also wipe the freshly-stored authToken
      //  during the login flow if a subsequent call like getuserInfo gets a 401)
      localStorage.removeItem('authToken');
      localStorage.removeItem('userLogged');
      localStorage.removeItem('userinfo');
      
      // Dispatch logout action to Redux
      store.dispatch(logout());
      
      // Redirect to home page after a short delay (allow toast to be seen)
      setTimeout(() => {
        window.location.href = '/';
      }, 1000);
      
      // Return error response
      return {
        error: 'Session expired. Please login again.',
        status: 401
      };
    }
    
    return response;
  } catch (error) {
    console.error('Network error:', error);
    throw error;
  }
};

/**
 * Helper to get response JSON and handle 401s
 * Usage: authFetch(url, options).then(handleAuthResponse)
 */
export const handleAuthResponse = async (response) => {
  // If already handled by authFetch (401), return the error object
  if (response.error && response.status === 401) {
    return response;
  }
  
  return response.json();
};
